import React, {useEffect, useState} from 'react';
import api from "../api/axios";
import {Calendar} from "lucide-react";

interface WordData {
    level: string;
    kanji: string;
    hiragana: string;
    meaning: string;
}

const TodayWordLoader = () => {
    const [words, setWords] = useState<WordData[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        const fetchWords = async () => {
            try {
                const response = await api.get('/api/words/today');
                const formattedData = response.data
                    .sort((a: any, b: any) => b.level - a.level)
                    .map((item: any) => ({
                        ...item,
                        level: `N${item.level}`
                    }));
                setWords(formattedData);
            } catch (err) {
                console.error("Failed to fetch:", err);
                setError(true);
            } finally {
                setLoading(false);
            }
        };

        fetchWords();
    }, []);

    if (loading) return <div className="p-10 text-center text-gray-500 dark:text-gray-400">오늘의 단어를 불러오는 중입니다...</div>;
    if (error) return <div className="p-10 text-center text-red-500 dark:text-red-400">데이터를 불러오지 못했습니다.</div>;

    // 데이터를 다 불러왔다면 UI 컴포넌트에게 전달합니다.
    // return <TodayWordsUI words={words} />;
    return (
        <div className="space-y-8">
            <div className="text-center space-y-2">
                <h2 className="text-3xl font-bold text-gray-800 flex items-center justify-center gap-2 dark:text-gray-100">
                    <Calendar className="w-8 h-8 text-orange-500"/>
                    오늘의 단어
                </h2>
                <p className="text-gray-500 dark:text-gray-400">매일 급수별로 하나의 단어를 마스터해보세요!</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
                {words.map((word) => (
                    <div key={word.level}
                         className="bg-white rounded-xl shadow-lg overflow-hidden transform hover:-translate-y-1 transition-transform duration-300 dark:bg-gray-800 dark:shadow-gray-900/50">
                        <div className={`h-2 w-full ${
                            word.level === 'N1' ? 'bg-red-500' :
                                word.level === 'N2' ? 'bg-orange-500' :
                                    word.level === 'N3' ? 'bg-yellow-500' :
                                        word.level === 'N4' ? 'bg-green-500' : 'bg-blue-500'
                        }`}/>
                        <div className="p-6 text-center">
                <span className="inline-block px-3 py-1 bg-gray-100 text-gray-500 text-xs font-bold rounded-full mb-4 dark:bg-gray-700 dark:text-gray-300">
                  {word.level}
                </span>
                            <div className="text-4xl font-black text-gray-800 mb-2 dark:text-gray-100">{word.kanji}</div>
                            <div className="text-xl text-indigo-600 mb-2 dark:text-indigo-400">{word.hiragana}</div>
                            <div className="text-gray-500 font-medium dark:text-gray-400">{word.meaning}</div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default TodayWordLoader;